// /src/pages/parallel/ParallelPersonasPage.js
import { useParallelPersona } from "../../context/ParallelPersonaContext";
import { useState } from "react";
import { useNavigate } from "react-router-dom";
import SummaryTable from "../../components/SummaryTable";
import HelpTooltip from "../../components/HelpTooltip";
import { exportToCsv, exportToJson, exportToPdf } from "../../services/export";
import Header from "../../components/Header";

const ParallelPersonasPage = () => {
  const navigate = useNavigate();
  const { personas, personaData } = useParallelPersona();
  const [visibleCount, setVisibleCount] = useState({});
  const [exportEnabled] = useState({ json: true, csv: true, pdf: true });

  const handleShowMore = (ethnicity, totalCount) => {
    setVisibleCount((prev) => ({ ...prev, [ethnicity]: totalCount }));
  };

  const handleShowLess = (ethnicity) => {
    setVisibleCount((prev) => ({ ...prev, [ethnicity]: 3 }));
  };

  const processString = (response) => {
    if (response.includes("They")) {
      let modifiedResponse = response
        .replace(/\bhas\b/g, "have")
        .replace(/\bdoes\b/g, "do")
        .replace(/\bdoesn't\b/g, "don't");

      let isCount = 0;
      modifiedResponse = modifiedResponse.replace(/\bis\b/g, (match) => {
        isCount++;
        return isCount > 1 ? "are" : match;
      });

      return modifiedResponse;
    }
    return response;
  };

  Object.keys(personas).map((ethnicity) => {
    personas[ethnicity].map((persona) => {
      persona["persona_characteristics"] = processString(
        persona["persona_characteristics"]
      );
    });
  });

  const handleCreatePersonaClick = () => {
    const confirmResubmission = window.confirm(
      "Are you sure to proceed? Your personas will be lost if you haven't exported it."
    );
    if (confirmResubmission) {
      navigate("/parallel/upload");
    }
  };

  const handleExport = (format) => {
    if (format === "json" && exportEnabled.json) {
      exportToJson(personaData);
    } else if (format === "pdf" && exportEnabled.pdf) {
      exportToPdf(personaData);
    } else if (format === "csv" && exportEnabled.pdf) {
      exportToCsv(personaData);
    }
  };

  return (
    <div className="result-page">
      <Header />
      <h2 className="page-title">Persona Result</h2>
      <div className="persona-sections">
        {Object.entries(personas).map(([ethnicity, personaList], idx) => (
          <section key={idx} className="ethnicity-section">
            <h3>{ethnicity}</h3>
            <div className="persona-cards">
              {personaList
                .slice(0, visibleCount[ethnicity] || 3)
                .map((persona, index) => (
                  <div key={index} className="persona-card">
                    <div className="persona-header">Persona {index + 1}</div>
                    <div className="persona-body">
                      {persona.persona_characteristics}
                    </div>
                    <div className="persona-footer">
                      Around{" "}
                      {Math.round(
                        persona.percentage_similar_respondants.toFixed(2)
                      )}
                      % of {ethnicity} respondents are similar
                    </div>
                  </div>
                ))}
            </div>
            <div className="persona-buttons">
              {(!visibleCount[ethnicity] ||
                visibleCount[ethnicity] < personaList.length) && (
                <button
                  className="next-button"
                  onClick={() => handleShowMore(ethnicity, personaList.length)}
                >
                  Show More
                </button>
              )}
              {visibleCount[ethnicity] > 3 && (
                <button
                  className="next-button"
                  onClick={() => handleShowLess(ethnicity)}
                >
                  Show Less
                </button>
              )}
            </div>
          </section>
        ))}
      </div>
      <div className="summary-section">
        <SummaryTable data={personaData} />
        <h4>
          NB:The count and order of genders and names used in the personas are
          randomised and are not based on the selected datasets.
        </h4>
      </div>
      <div className="bottom-controls">
        <button
          onClick={() => navigate("/parallel/confirm")}
          className="back-button"
        >
          Back
        </button>
        <button
          onClick={handleCreatePersonaClick}
          className="generate-again-button"
        >
          Generate Again
        </button>
        <div className="export-dropdown">
          <button className="export-button">Export ▲</button>
          <div className="dropdown-content">
            <button
              onClick={() => handleExport("json")}
              disabled={!exportEnabled.json}
              className={exportEnabled.json ? "enabled" : "disabled"}
            >
              Export as JSON
            </button>
            <button
              onClick={() => handleExport("csv")}
              disabled={!exportEnabled.csv}
              className={exportEnabled.csv ? "enabled" : "disabled"}
            >
              Export as CSV
            </button>
            <button
              onClick={() => handleExport("pdf")}
              disabled={!exportEnabled.pdf}
              className={exportEnabled.pdf ? "enabled" : "disabled"}
            >
              Export as PDF
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ParallelPersonasPage;
